import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { InventoryConfig } from '../../pages/Settings';
import { MimaToastUtil } from '../../components';
import { InventoryController } from '../../controllers';
import constant from '../../utils/constant';
import { toJS, values } from 'mobx';
import { inventoryStore } from '../../stores';

const InventoryConfigContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		const getConfig = async () => {
			await InventoryController.getConfig();
			setLoading(false);
		}
		getConfig();
	}, [])

	const goBack = () => {
		closeModal();
	};

	const onSubmit = async values => {
		const payload = {
			splitPaymentTrigger: values.splitPaymentTrigger,
			depositPer: values.depositPer,
			vat: values.vat,
			lowStockReminderTimer: values.lowStockReminderTimer,
			termsAndConditions: values.termsAndConditions,
		}
		setLoading(true);
		const { status, errorMessage } = await InventoryController.updateConfig(payload);
		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
		} else {
			return MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};

	const reminderTime = [
		{
			key: 0,
			value: "None"
		},
		{
			key: 6,
			value: "Every 6hrs"
		},
		{
			key: 12,
			value: "Every 12hrs"
		},
		{
			key: 24,
			value: "Every 24hrs"
		},
		{
			key: 48,
			value: "Every 48hrs"
		},
		{
			key: 72,
			value: "Every 72hrs"
		},
		{
			key: 168,
			value: "Every Week"
		},
		{
			key: 672,
			value: "Every Month"
		}
	]

	return (
		<InventoryConfig
			reminderTime={reminderTime}
			closeModal={closeModal}
			goBack={goBack}
			onSubmit={onSubmit}
			loading={loading}
			productConfig={toJS(inventoryStore.productConfig)}
		/>
	);
};

export default observer(InventoryConfigContainer);